import React, { memo } from "react";
import { Button, ButtonGroup } from "reactstrap";

import { BooleanTaxonomyEntry } from "../../types";
import { InputComponentProps } from "./common";

const BooleanInputComponent = ({
  id,
  onFocus,
  onUpdate,
  value,
}: InputComponentProps<BooleanTaxonomyEntry, boolean>) => {
  return (
    <>
      <ButtonGroup className="boolean-input" id={id}>
        <Button
          color="primary"
          onClick={() => {
            onFocus(id);
            onUpdate(id, true, "true");
          }}
          outline={value.value !== true}
          type="button"
        >
          Yes
        </Button>
        <Button
          color="primary"
          onClick={() => {
            onFocus(id);
            onUpdate(id, false, "false");
          }}
          outline={value.value !== false}
          type="button"
        >
          No
        </Button>
      </ButtonGroup>
    </>
  );
};
BooleanInputComponent.displayName = "BooleanInput";
export const BooleanInput = memo(BooleanInputComponent);
